export const generateQRCode = (url) => {
  return new Promise((resolve) => {

    const QRCode = require('qrcode');
    QRCode.toDataURL(url, (err, url) => {
      if (err) {
        console.error('QR generation error:', err);
        resolve(null);
      }
      resolve(url);
    });
  });
};

export const downloadQRCode = (qrUrl, fileName = 'business-card-qr.png') => {
  const link = document.createElement('a');
  link.href = qrUrl;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};